module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon5.78a96a22.svg";